// src/services/baseURL.jsx
// const BASE_URL = "http://localhost:4002/api";

export const BASE_URL = "https://backendapi.edjamon.com/api";

export default BASE_URL;
